// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"491":"error-clock","714":"WidgetApp","757":"game","825":"input-widgets"}[chunkId] + "." + {"491":"e423f6a373ef8d21477a","714":"befcf897ffcf4304cde6","757":"2e4ef75683a69c1eda28","825":"a5216013ef1636af3d05"}[chunkId] + ".js";
};